
    export enum EnumFacilityType {
			Plant = 0,
			Company = 1,
    }